import React from 'react';

import cx from 'classnames';
import { Controller } from 'react-hook-form';

import { Alert } from 'components/shared/Alert';
import { AModal } from 'components/shared/AModal';
import { BaseSelect } from 'components/shared/BaseFormComponents/Select';
import Button from 'components/shared/Button';
import { HookCheckbox } from 'components/shared/HookFormComponents';

import cs from '../../../Itinerary/Details/DetailsChronologicalMode/Event/ModalContents/Edit/index.module.css';
import useGuestSearchForm, { connectionToOptionAdapter } from './functions';
import s from './index.module.css';
import { IGuestSearchProps } from './types';

const GuestSearchForm = (props: IGuestSearchProps) => {
  const {
    isSubmitting,
    loadGuests,
    control,
    companions,
    showCompanions,
    submitHandler,
    mainGuest,
    resetCompanionsOnGuestChange,
  } = useGuestSearchForm(props);

  return (
    <AModal
      size="auto"
      header="Search Existing Guests"
      isOpen
      onClose={props.onClose}
      bodyClassName={s.modalBody}
      headerClassName={s.modalHeader}
    >
      <div className={s.wrapper} style={{ gap: showCompanions ? '24px' : '14px' }}>
        <div className={s.search}>
          Search existing guests by First, Middle, Last Names and Email
          <Controller
            name="mainGuest"
            control={control}
            render={({ field: { onChange } }) => (
              <BaseSelect
                isClearable
                onChange={(_, id) => {
                  onChange(id);
                  resetCompanionsOnGuestChange();
                }}
                placeholder="Search"
                onOptionActionClick={() => {}}
                optionClassName={s.guestOption}
                loadOptions={loadGuests}
              />
            )}
          />
        </div>
        {showCompanions && (
          <div className={s.companionsWrapper}>
            <div className={s.title}>Travel Companions</div>
            <div className={s.description}>
              It seems this traveler has traveled with others in the past. Would you like to include any of them on this
              trip as well?
            </div>
            <div className={s.companions}>
              {companions?.map((companion, idx) => {
                const { title } = connectionToOptionAdapter(companion);

                return (
                  <HookCheckbox key={title + idx} control={control} className={s.companion} name={`companions[${idx}]`}>
                    {title}
                  </HookCheckbox>
                );
              })}
            </div>
          </div>
        )}
        <Alert
          variant="info"
          className={s.alert}
          content={
            <>
              <p>
                Heads up! This will pull in information from the last time each field of the guest form was completed by
                this guest.{' '}
                <span className={s.headsUp}>
                  In order for passports and health & dietary information to copy over, they had to give permission for
                  the information to be kept on file.
                </span>
              </p>
              <br />
              Warning: You should confirm all information is up to date.
            </>
          }
        />
      </div>
      <div className={cx(cs.footer, s.footer)}>
        <Button
          onClick={submitHandler}
          className={s.submitBtn}
          disabled={!mainGuest || isSubmitting}
          size="medium"
          htmlType="button"
        >
          Select
        </Button>
      </div>
    </AModal>
  );
};

export default GuestSearchForm;
